// based on rc-progress 2.5.2
import Progress, { Line, Circle } from './src/';

export { Line, Circle };

export default Progress;
